<template>
  <div class="contact-method-list">
    <contact-method
      v-for="(item, index) in value"
      :key="`${item.name}-${item.id}`"
      :item="item"
      class="contact-method-list__item"
    >
      <template slot="controls">
        <table-control type="trash" @click="remove(index)" />
      </template>
    </contact-method>
  </div>
</template>

<script>
  import ContactMethod from '@pbx/components/contact-methods/item';
  import cloneDeep from 'lodash-es/cloneDeep';

  export default {
    components: { ContactMethod },
    props: {
      value: {
        type: Array,
        default: () => []
      }
    },

    methods: {
      remove: function(remove_index) {
        const current_value = cloneDeep(this.value);
        const new_value = current_value.filter((item, index) => index !== remove_index);
        this.$emit('input', new_value);
      }
    }
  };
</script>

<style lang="scss" scoped>
  .contact-method-list {
    border-top: 1px solid $grey;

    &__item {
      border-bottom: 1px solid $grey;
      padding: 10px 0;
    }
  }
</style>
